import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import createApiService from '../../../common/clientActionsBuilder';
import {Button, Col, ControlLabel, Form, FormGroup, Glyphicon, Grid, Modal, Row} from 'react-bootstrap';
import ResourceComponent from '../../../components/ResourceComponent';
import * as serviceConfigurationApi from './ServiceConfigurationApi';
import {browserHistory} from 'react-router';
import ColorCheckbox from '../../Scheduler/ColorCheckbox';
import {select} from '../../../common/commonHandlers';
import Select from 'react-select';
import classNames from 'classnames';

const api = createApiService('clients', 'client', 'Client');
const actions = {...api, ...serviceConfigurationApi};

class QuickbooksTab extends ResourceComponent {


    constructor(props, context) {
        super(props, context);
        this.state = {
            resource: {},
            credentials: {},
            quickbooksCredentials: {},
            showModal: false,
            showConnectModal: false,
            resetQuickbooks: false,
            resetQuickbooksOnConnect: false
        };
        this.qbAccountSearch = {
            searchOptions: () => [],
            search: () => {
            },
        };
    }

    componentDidMount() {
        this.reload();
        this.qbAccountSearch = this.buildSearchComponent('qb_account', this.props.actions.searchForQbAccount);

    }

    reload = () => {
        this.props.actions.get(this.props.id, resource => this.setState({resource}));
        this.props.actions.loadQuickbooksCredentials(result => {
            this.setState({quickbooksCredentials: result});
            this.qbAccountSearch.search(result.income_account);
        });
    };

    handleDisconnect = () => {
        this.props.actions.disconnectQuickbooks(this.state.resetQuickbooks, () => {
            this.setState({showModal: false})
            this.reload();
        });
    }

    connectWithQuickbooks = (resetQuickbooks = false) => {
        this.props.actions.connectWithQuickbooks(resetQuickbooks, result => {
            window.location.replace(result.data.url);
        });
    }

    handleConnect = () => {
        if (this.state.quickbooksCredentials.has_cached_data) {
            this.setState({
                showConnectModal: true,
                resetQuickbooksOnConnect: false
            });
            return;
        }

        this.connectWithQuickbooks();
    }

    handleConnectConfirm = () => {
        this.connectWithQuickbooks(this.state.resetQuickbooksOnConnect);
    }

    render() {
        const {resource, quickbooksCredentials} = this.state;
        const accountOptions = this.qbAccountSearch.searchOptions();
        const hasQuickbooksCredentials = quickbooksCredentials && Object.keys(quickbooksCredentials).length > 0;
        return (
            <>
                <Grid fluid className='top25'>
                    <Form horizontal onSubmit={e => {
                        e.preventDefault();
                        this.props.actions.saveQbSettings(resource.income_account_id, resource.auto_qb_sync);
                    }}>
                        <Row className='top50'>
                            <Col md={9}>
                                <FormGroup>
                                    <Col mdOffset={4}>
                                        <Col md={8}>
                                            <h4>Quickbooks</h4>
                                        </Col>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={9}>
                                <FormGroup>
                                    <Col componentClass={ControlLabel} md={4}>
                                        Connect with Quickbooks
                                    </Col>
                                    <Col md={6}>
                                        {quickbooksCredentials.quickbooks_realm_id ?
                                            <a className='connect-button disconnect'
                                               onClick={() => this.setState({showModal: true})}>
                                                <span>Disconnect</span>
                                            </a>
                                            :
                                            <a className={classNames('connect-button quickbooks', {disabled: !hasQuickbooksCredentials})}
                                               onClick={() => {
                                                   if (!hasQuickbooksCredentials) {
                                                       return;
                                                   }
                                                   this.handleConnect();
                                               }}><span><img src='quickbooks.png' /> Connect</span></a>
                                        }
                                        {quickbooksCredentials.quickbooks_realm_id &&
                                            <a className='connect-button sync ml-9'
                                               onClick={() => browserHistory.push(`/quickbooks`)}><span>Sync</span></a>}
                                        <div className='mt-15'>
                                            <Glyphicon glyph='info-sign text-info' className='notification' />
                                            <span className='text-info text-small small-margin'>
                                We allow importing following quickbooks custom fields: Sales Rep, Proposal Number.
                                If you want them to be imported in your invoices please add them manually in your quickbooks online account through quickbooks admin.
                            </span>
                                        </div>
                                        <div className='mt-15'>
                                            <Glyphicon glyph='info-sign text-info' className='notification' />
                                            <span className='text-info text-small small-margin'>
                                For services synchronization you have to go to your quickbooks account and enable classes.
                            </span>
                                        </div>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={9}>
                                <Row>
                                    <Col componentClass={ControlLabel} md={4}>
                                        Allow automatic synchronization
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup bsSize='small'>
                                            <ColorCheckbox value={resource.auto_qb_sync}
                                                           label='Allow automatic sync on for customers and services'
                                                           onChange={this.selectCheckboxAttr('auto_qb_sync')}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={9}>
                                <FormGroup>
                                    <Col componentClass={ControlLabel} md={4}>
                                        <span>Pick an income account</span>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup bsSize='small'>
                                            <Select className='Select'
                                                    classNamePrefix='select'
                                                    value={select(accountOptions, resource.income_account_id)}
                                                    options={accountOptions}
                                                    placeholder='Account'
                                                    isClearable
                                                    onInputChange={this.qbAccountSearch.search}
                                                    onChange={this.selectResourceAttr('income_account_id')}
                                            />
                                        </FormGroup>
                                        <div className='mt-15'>
                                            <Glyphicon glyph='info-sign text-info' className='notification' />
                                            <span className='text-info text-small small-margin'>
                                            For services synchronization you have to pick an income account.
                                        </span>
                                        </div>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col mdOffset={3} md={1}>
                                <Button
                                    block
                                    type='submit'
                                    bsStyle='success'
                                >
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Grid>
                <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({showModal: false})}
                    className="heightAuto maxHeight90 modalLeadsFilterBody fontIOS"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Disconnect quickbooks</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="preview_modal">
                        <h4>This action will disconnect your client with quickbooks service.</h4>
                        <ColorCheckbox
                            value={this.state.resetQuickbooks}
                            label="Reset all quickbooks cache data for client."
                            onChange={(checked) => this.setState({ resetQuickbooks: checked })}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='warning' onClick={() => this.setState({showModal: false})}>
                            Close
                        </Button>
                        <Button bsStyle='success' onClick={this.handleDisconnect}>
                            Disconnect
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.showConnectModal}
                    onHide={() => this.setState({showConnectModal: false})}
                    className="heightAuto maxHeight90 modalLeadsFilterBody fontIOS"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Connect quickbooks</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="preview_modal">
                        <h4>Existing quickbooks data was found for this client.</h4>
                        <ColorCheckbox
                            value={this.state.resetQuickbooksOnConnect}
                            label="Reset all quickbooks cache data for client before connecting."
                            onChange={(checked) => this.setState({resetQuickbooksOnConnect: checked})}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='warning' onClick={() => this.setState({showConnectModal: false})}>
                            Close
                        </Button>
                        <Button bsStyle='success' onClick={this.handleConnectConfirm}>
                            Connect
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        state: state,
        clientId: state.auth.client_id,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickbooksTab);
